export default "__VITE_ASSET__BTmoliyX__"